export { ReactComponent as TextAlignLeft } from './svgs/align-text-left.svg';
